import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'asiToggle' })
export class AsiToggle implements PipeTransform {

  constructor() {
  }

  transform(value: any, yes: any, no: any) {
    return value ? yes : no;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/pipe/asiToggle.pipe.ts